import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DossierEmitHelper } from '@app-services/dossier.service';

@Component({
  selector: "app-full-dossier-card",
  templateUrl: "./full-dossier-card.component.html",
  styleUrls: ["./full-dossier-card.component.scss"],
})
export class FullDossierCardComponent implements OnInit {
  @Input() dossierStatus: string;
  @Input() numberPlate: string;
  @Input() lastUpdated: Date;
  @Input() dossierPrice: number;

  showRepurchaseDossier: boolean;

  loading = false;

  @Output()
  buyDossier = new EventEmitter<DossierEmitHelper>();

  constructor() { }

  ngOnInit() { }

  buyFullDossier(): void {

    let dossierEmit = new DossierEmitHelper();
    dossierEmit.callback = (sucess: boolean) => {
      this.loading = false;
    }
    dossierEmit.isRepurchase = false;

    this.buyDossier.emit(dossierEmit);
    this.loading = true;
  }

  repurchaseDossier(): void {

    let dossierEmit = new DossierEmitHelper();
    dossierEmit.callback = (sucess: boolean) => {
      this.loading = false;
    }
    dossierEmit.isRepurchase = true;

    this.buyDossier.emit(dossierEmit);
    this.loading = true;
    this.showRepurchaseDossier = false;
  }

  openRepurchaseDossierModal(): void {
    this.showRepurchaseDossier = true;
  }

  closeRepurchaseDossierModal(): void {
    this.showRepurchaseDossier = false;
  }
}
